import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const postSaveLTPlannerMaterial = createApi(`SaveLTPlannerMaterialSlice`,"POST");

const SaveLTPlannerMaterialSlice = createSlice({
  name: 'SaveLTPlannerMaterialSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postSaveLTPlannerMaterial.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postSaveLTPlannerMaterial.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postSaveLTPlannerMaterial.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default SaveLTPlannerMaterialSlice.reducer;